const AxiosPlugin = {}

AxiosPlugin.install = function (Vue, http) {
  Vue.prototype.$axios = http;
}

export default AxiosPlugin
